import {
    Box,
    Button,
    TextField,
    Typography,
} from "@mui/material";
import { getAuth } from "firebase/auth";
import React from "react";
import AppBarAccount from "../components/AppBar/Account";
import { useNavigateToTop } from "../libs/useNavigateToTop";
import AppBarFeedback from "../components/AppBar/Feedback";
import { uploadData } from "../libs/firebase/firestore/uploadData";
  
  function ScreenFeedback({}) {
    const navigate = useNavigateToTop();

    //state for comment
    const [comment, setComment] = React.useState("");
  
    const currentUser = getAuth().currentUser;

    const handleSendFeedback = () => {
        // Send to firebase
        const data = {
            comment: comment,
            userId: currentUser.uid,
            createdAt: new Date(),
        };

        uploadData(data, "feedback", (docRef) => {
            alert("Feedback sent!");
            setComment("");
            navigate(-1);
        });

        
    }
    return (
      <Box>
        <AppBarFeedback />
        <Box
          sx={{
            padding: "1rem",
            margin: "auto",
            // maxWidth: "1200px",
          
          }}
        >
            <Typography variant="h4">Feedback</Typography>
          <Typography gutterBottom
            sx={{
              marginBottom: "1rem",
            }}
          >
            If you have some feedback or suggestions for things you would like to see added to the app, please send a message in the box below.
          </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                }}
            >
                <TextField
                    rows={4}
                multiline
                fullWidth
                value={comment}
                onChange={(e) =>
                    setComment(e.target.value)
                }
                placeholder="Enter your comments here"
            />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSendFeedback}
                >
                    Send Feedback
                </Button>



        </Box>
        </Box>
      </Box>
    );
  }
  
  export default ScreenFeedback;
  